<template>
  <div
    class="popup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="reqpop"
  >
    <!-- @mouseleave="close"> -->
    <div class="top" v-if="!mobile">
      <div class="title">{{ event.title }}</div>
      <button class="close" @click="close">
        <img src="@/assets/images/icons/close.svg" alt="" />
      </button>
    </div>
    <div class="mobile-header" v-if="mobile">
      <div class="title">
        Детали записи
      </div>
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <div class="info">
      <div class="text">
        {{ getCoworkingName(event.extendedProps.cowork) }}
      </div>
      <template v-if="event.extendedProps">
        <div class="payed" v-if="event.extendedProps.payed">
          рабочее место оплачено
        </div>
        <div class="payed error" v-if="event.extendedProps.error">
          рабочее место не оплачено
        </div>
      </template>
      <div class="text">
        {{
          `${$moment(event.start).format("ddd, DD MMMM, HH:mm")} - ${$moment(
            event.end
          ).format("HH:mm")}`
        }}
      </div>
    </div>
    <button class="save" @click="cancel()" v-if="canCancel">
      Отменить бронирование
    </button>
  </div>
</template>

<script>
// import moment from "moment";

import moment from "moment";

export default {
  name: "detailsRWDialog",
  props: {
    coworking: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    show: false,
    mobile: false,
    jsEvent: null,
    event: {
      title: "",
      id: 0,
      extendedProps: {
        price: 0,
        error: false,
        payed: false,
      },
      start: new Date(),
      end: new Date(),
    },
  }),
  computed: {
    canCancel() {
      return moment().isBefore(this.event.end, "minute");
    },
  },
  methods: {
    cancel() {
      let description = null;
      if (this.event.extendedProps.records_count)
        description =
          "Вы действительно хотите отменить бронирование, подтвержденное заказами клиентов?";
      this.$emit("delete", this.event.id, description);
      this.close();
    },
    open(e) {
      this.clear();
      this.event = e.event;
      this.jsEvent = e.jsEvent;
      if (window.innerWidth < 425) {
        this.mobile = true;
        this.$refs.reqpop.style.left = "0px";
        this.$refs.reqpop.style.bottom = "0px";
      } else {
        this.mobile = false;
        //offsets section
        let w = this.$refs.reqpop.offsetWidth;
        let h = this.$refs.reqpop.offsetHeight;
        let left = Math.abs(
          e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
        );
        let offset = 10;
        let lofSet = document.body.clientWidth - left;
        if (lofSet > 0) {
          lofSet = offset;
        } else {
          lofSet = -e.jsEvent.target.clientWidth - w - offset;
        }
        left -= w;
        let scrY = window.scrollY;
        if (
          document.body.offsetHeight <
          e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
        )
          scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
        //offsets end
        this.$refs.reqpop.style.left = left + lofSet + "px";
        this.$refs.reqpop.style.top =
          Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";
      }
      this.$emit("opened");
      this.show = true;
    },
    clear() {
      this.event = {
        title: "",
        id: 0,
        extendedProps: {
          price: 0,
          error: false,
          payed: false,
        },
        start: new Date(),
      };
    },
    close() {
      this.show = false;
    },
    getCoworkingName(id) {
      if (this.coworking.length == 0 || id == (undefined || null)) return "";
      let key = 0;
      this.coworking.forEach((item, i) => {
        if (item.id == id) {
          key = i;
        }
      });
      return this.coworking[key].title;
    },
  },
};
</script>

<style scoped lang="scss">
.payed {
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0f8a84;
  margin-bottom: 15px;
}

.payed.error {
  color: darkred;
}

hr {
  margin: 15px 0;
  color: #dbbfa7;
  border: none;
  background-color: #dbbfa7;
  height: 1px;
}

.popup {
  position: absolute;
  right: 0;
  top: 500px;
  max-width: 300px;
  width: 100%;
  border: 2px solid #dbbfa7;
  border-radius: 5px;
  background-color: #fff;
  padding: 15px 20px 20px 20px;
  z-index: 500;

  .mobile-header {
    border-radius: 10px 10px 0 0;
    background: #dbbfa7;
    height: 50px;
    position: absolute;
    left: 0;
    right: 0;
    top: -49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px;

    &.title {
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
    }

    & button {
      background-color: transparent;
      border: none;
      width: 20px;
      height: 20px;

      img {
        max-width: 100%;
      }
    }
  }
}

.title {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #808080;
}

.rent {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #b9765b;
}

.top {
  display: flex;
  margin-bottom: 15px;

  & .title {
    margin-right: auto;
    font-weight: 600;
  }

  button {
    border: none;
    background-color: transparent;
    margin-left: 10px;
    filter: grayscale(100%);
  }
}

.close {
  width: 22px;
  min-width: 22px;
  height: 22px;

  img {
    width: 100%;
  }
}

.save {
  height: 48px;
  margin-left: -22px;
  margin-right: -22px;
  width: calc(100% + 44px);
  margin-bottom: -2px;
  transform: translateY(20px);
  border: 2px solid #dbbfa7;
  background-color: #fff;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #808080;
}

@media (max-width: 425px) {
  .popup {
    max-width: 100%;
    position: fixed;
    left: 0 !important;
    top: unset !important;
    bottom: 0;
    right: 0;
    border: unset;
  }

  .save {
    width: 100%;
    border-radius: 5px;
    border: unset;
    background-color: transparent;
    color: #e05252;
    font-weight: 600;
    margin: 15px auto;
  }
  .person {
    flex-wrap: wrap;
  }
  .person-data {
    width: 80%;
    margin-bottom: 15px;
  }
}
</style>
